import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  EventResourceSecurityResource,
  EventResourceSecurityResourceAction,
  Resource,
  ResourceTag,
} from '@greco/booking-events';
import { SecurityService } from '@greco/ngx-security-util';
import { PropertyListener } from '@greco/property-listener-util';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ResourcesService } from '../../../services';

@Component({
  selector: 'greco-zoom-resource-page',
  templateUrl: './zoom-resource.page.html',
  styleUrls: ['./zoom-resource.page.scss'],
})
export class ZoomResourcePage implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private securitySvc: SecurityService,
    private resourceSvc: ResourcesService
  ) {}

  @PropertyListener('resource') private resource$ = new BehaviorSubject<Resource | null>(null);
  @Input() resource!: Resource;

  canUpdateResource$ = this.resource$.pipe(
    switchMap(async resource => {
      return resource
        ? await this.securitySvc.hasAccess(
            EventResourceSecurityResource.key,
            EventResourceSecurityResourceAction.UPDATE_ZOOM,
            { communityId: resource.community.id }
          )
        : false;
    })
  );

  saving = false;

  canUpdate = true;

  initialValue: any;
  formGroup = this.formBuilder.group({
    name: ['', Validators.required],
    description: [''],
    resourceTags: [[]],
  });

  async ngOnInit() {
    this.resource = await this.resourceSvc.getResource(this.resource.id);
    this.initialValue = {
      name: this.resource.name,
      description: this.resource.description,
      resourceTags: this.resource.resourceTags,
    };
    this.formGroup.reset(this.initialValue);
  }

  onSave = async () => {
    this.saving = true;

    try {
      if (
        this.initialValue.name != this.formGroup.value.name ||
        this.initialValue.description != this.formGroup.value.description ||
        this.initialValue.resourceTags != this.formGroup.value.resourceTags
      ) {
        this.resource = await this.resourceSvc.updateResource(this.resource.id, {
          name: this.formGroup.value.name,
          description: this.formGroup.value.description,
          resourceTagIds: (this.formGroup.value.resourceTags as ResourceTag[]).map(resourceTag => resourceTag.id),
        });
      }

      this.initialValue = {
        name: this.formGroup.value.name,
        description: this.formGroup.value.description,
        resourceTags: this.resource.resourceTags,
      };
      this.formGroup.reset(this.initialValue);
      this.formGroup.markAsPristine();
    } catch (err) {
      console.log(err);
    }

    this.saving = false;
  };

  async setDisable() {
    const isDisabled = this.resource.disabled;
    try {
      this.resource = await this.resourceSvc.updateResource(this.resource.id, {
        disabled: !isDisabled,
      });
    } catch (err) {
      console.log(err);
    }
  }
}
